/** Service Desk console: pagsasama ng isang organisasyon sa iba (ORG-005, SD-S4-07). */
export const serviceMerge = {
  title: "Pagsamahin ang {{name}}",
  step: {
    target: "Hakbang 1 sa 2: piliin ang organisasyong mananatili.",
    review: "Hakbang 2 sa 2: suriin ang lilipat, ayusin ang mga doble at kumpirmahin.",
    done: "Tapos na ang pagsasama.",
  },
  actions: {
    open: "Isama sa…",
    preview: "I-preview ang pagsasama",
    previewAgain: "I-preview ulit",
    apply: "Pagsamahin ang mga organisasyon",
    back: "Bumalik",
  },
  target: {
    intro: "Lahat ng pag-aari ng {{name}} (mga tao, ticket, asset at iba pa) ay lilipat sa organisasyong pipiliin mo. Walang buburahin.",
    search: "Hanapin ang organisasyong mananatili",
    searchHint: "Maghanap ayon sa pangalan o code. Hindi inaalok ang mga naka-archive.",
    placeholder: "Maghanap ng organisasyon",
    loading: "Naghahanap ng mga organisasyon",
    errorTitle: "Hindi ma-load ang mga organisasyon",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit. Walang binago.",
    emptyTitle: "Walang organisasyong mapagsasamahan",
    emptyBody: "Magdagdag muna ng isa pang organisasyon, saka bumalik para magsama.",
    emptySearch: "Walang aktibong organisasyong tumutugma sa “{{term}}”. Subukan ang mas maikling pangalan o ang code nito.",
    results_one: "{{count}} organisasyon",
    results_other: "{{count}} organisasyon",
    contacts_one: "{{count}} contact",
    contacts_other: "{{count}} contact",
    note: "Makikita mo nang eksakto ang lilipat at ang magbabanggaan bago may mangyari.",
  },
  review: {
    source: "Mawawala (ia-archive)",
    target: "Mananatili",
    summary: "Ia-archive ang {{source}} na may tala na tumuturo sa {{target}}. Lilipat ang mga record nito sa {{target}}, at mananaig ang sariling detalye ng {{target}} kung pareho silang mayroon.",
  },
  counts: {
    title: "Ang lilipat",
    preview: "Preview",
    caption: "Mga record na lilipat mula {{source}} papunta sa {{target}}",
    type: "Uri ng record",
    count: "Mga record",
    total: "Kabuuan",
    nothing: "Walang record na ililipat ang organisasyong ito. Ang mga detalye na lang nito ang isasama.",
    discarded_one: "{{count}} naka-cache na entry ng connector ang itatapon at bubuuin ulit sa susunod na sync.",
    discarded_other: "{{count}} naka-cache na entry ng connector ang itatapon at bubuuin ulit sa susunod na sync.",
  },
  groups: {
    contacts: "Mga contact",
    tickets: "Mga ticket",
    assets: "Mga asset",
    contracts: "Mga kontrata",
    projects: "Mga proyekto",
    visits: "Mga pagbisita",
    orders: "Mga order",
    quotes: "Mga quote",
    carts: "Mga cart",
    approvals: "Mga pag-apruba",
    rmas: "Mga RMA",
    sites: "Mga site",
    attachments: "Mga kalakip",
    catalogue: "Visibility ng catalogue",
    leads: "Mga conversion ng lead",
    other: "Iba pang record",
  },
  fields: {
    title: "Mga detalye ng organisasyon",
    filled: "Kinuha mula sa organisasyong mawawala:",
    kept: "Pinanatili mula sa organisasyong mananatili (pareho silang mayroon):",
    domainsMoved: "Mga e-mail domain na dinala:",
    domainsLeft: "Mga e-mail domain na naiwan (lampas sa limitasyon):",
    notesTrimmed: "Mga tala:",
    notesTrimmedBody: "pinagsama, at pinaikli ang pinakaluma para magkasya.",
    industry: "industriya",
    tier: "tier",
    account_manager_user_id: "account manager",
    default_team_id: "default na team",
    price_list_ref: "listahan ng presyo",
    payment_terms: "termino ng bayad",
    billing_address: "billing address",
    shipping_address: "shipping address",
    order_settings: "mga patakaran sa pag-order",
    portal_settings: "setting ng portal",
    attributes: "mga custom na attribute",
    tin: "TIN",
  },
  conflicts: {
    title_one: "{{count}} doble na aayusin",
    title_other: "{{count}} doble na aayusin",
    intro: "Pareho silang may iisang bagay. Piliin kung paano hahawakan ang bawat isa; nakasara ang pagsasama hangga't hindi kumpleto ang mga pili.",
    none: "Walang doble. Walang kailangang piliin.",
    list: "Mga dobleng aayusin",
    blockedList: "Mga dobleng humaharang sa pagsasama",
    blockedDefault: "Hindi ito maaayos dito. Ayusin sa record, saka mag-preview ulit.",
    choose: "Pumili ng isa",
    chosen: "Napili na",
    kind: {
      site_name: "Pareho silang may site na “{{name}}”.",
      catalogue_visibility: "Pareho nilang nililimitahan ang mga produktong nakikita nila.",
      contact_email: "May contact na may e-mail na {{email}} sa dalawang organisasyon.",
      asset_serial: "May asset na may serial na {{serial}} ({{manufacturer}}) sa dalawang organisasyon.",
    },
    option: {
      merge: "Gawing isang site",
      rename: "Panatilihin ang dalawang site",
      keep_target: "Panatilihin ang patakaran ng organisasyong mananatili",
      use_source: "Gamitin ang patakaran ng organisasyong mawawala",
    },
    optionHint: {
      merge: "Lilipat sa site na mananatili ang lahat ng tumuturo sa lumang site, at ia-archive ang luma.",
      rename: "Papalitan ang pangalan ng lumang site at lalagyan ng pangalan ng organisasyon sa panaklong para makilala ang dalawa.",
      keep_target: "Tatanggalin ang mga patakaran sa produkto ng organisasyong mawawala.",
      use_source: "Papalitan ng sa kabila ang mga patakaran sa produkto ng organisasyong mananatili.",
    },
    blocked: {
      contact_email: "Isang beses lang maitatala ang isang tao. I-archive o ilipat ang isa sa dalawang contact, saka mag-preview ulit.",
      asset_serial: "Isang beses lang maitatala ang isang serial number. Itama o i-archive ang isa sa dalawang asset, saka mag-preview ulit.",
    },
  },
  confirm: {
    title: "Hindi na ito mababawi",
    body: "Ia-archive ang {{source}} at permanenteng lilipat ang lahat ng nasa itaas. Para kumpirmahin, i-type ang pariralang nasa ibaba.",
    label: "I-type ang parirala para kumpirmahin",
    hint: "I-type nang eksakto:",
    ready: "Handa nang pagsamahin.",
    why: {
      blocked: "May doble sa itaas na humaharang sa pagsasama. Ayusin ito, saka mag-preview ulit.",
      unsettled: "Piliin kung paano hahawakan ang bawat doble para mabuksan ang pagsasama.",
      phrase: "I-type nang eksakto ang parirala para mabuksan ang pagsasama.",
    },
  },
  progress: {
    title_one: "Inililipat ang {{count}} record sa {{target}}…",
    title_other: "Inililipat ang {{count}} record sa {{target}}…",
    hint: "Isang hakbang lang ito. Kung may pumalya, walang magbabago at puwede mong subukan ulit.",
  },
  result: {
    done_one: "Naisama ang {{source}} sa {{target}}. {{count}} record ang lumipat.",
    done_other: "Naisama ang {{source}} sa {{target}}. {{count}} record ang lumipat.",
    archived: "Naka-archive ang {{source}} at may tala kung saan ito napunta.",
    openTarget: "Buksan ang {{target}}",
    moved: "Mga record na lumipat ayon sa table ({{count}})",
    auditTitle: "Audit trail",
    auditRecorded: "Naitala sa audit log ang pagsasama.",
    auditAction: "Naisama ang organisasyon",
    auditSystem: "Sistema",
  },
  pointer: {
    prefix: "Naisama sa",
    on: " noong {{date}}. Nandoon na ngayon ang mga tao, ticket at asset nito.",
  },
  errors: {
    stale: "Nagbago ang mga organisasyon mula nang mag-preview ka. Walang naisama. Mag-preview ulit para makita ang kasalukuyan.",
    notConfirmed: "Kumpirmahin ang pagsasama para magpatuloy. Hindi na ito mababawi.",
    same: "Hindi maisasama ang organisasyon sa sarili nito.",
    notFound: "Wala na ang isa sa mga organisasyon. Isara ito at mag-reload.",
    forbidden: "Wala kang pahintulot na magsama ng mga organisasyon.",
  },
} as const;
